(function (ws) {
    'use strict';
    ws.views.orderDetail = ws.views.googleAnalytics.extend({

        events: {
            'click #pdfData a': 'trackPdfClickEvent',
            'click .view-packingSlip': 'trackPackingSlipClickEvent',
            'click .view-licenses': 'trackLicenses',
            'click .latestMsgUpdate': 'pushLatestMessageFunction'
        },

        /**
         * Google Analytics Variables
         */
        GTM_EVENT_CATEGORY: 'order_activity',
        GTM_EVENT_ACTION: 'sales order acknowledgement',
        GTM_EVENT_PACKING_SLIP_ACTION: 'packing_slip',
        GTM_EVENT_PACKING_SLIP_LABEL: 'order_detail_click_view_packing_slip',

        /**
         * Initialize
         */
        initialize: function() {
            this.getPdf(this.$('#pdfData').data('order-number'));
            this.sapOrderDate = this.$('#sapOrderDate').val();
            this.releaseDate = '14/12/2019';

            if (!moment(this.releaseDate, dateFormat, true).isBefore(moment(this.sapOrderDate, dateFormat, true))) {
                this.$('.vatPrice').hide();
                this.$('.totalValueLabel').html(this.$('.totalValueLabel').html().trim().split('(')[0]);
            }

            let totalValue = this.$('.totalValue').html().trim().split(' ')[1];
            let totalPrice = this.$('.totalPrice').html().trim().split(' ')[1];
            let totalFreight = this.$('.totalFreight').html().trim().split(' ')[1];

            if (totalValue === totalPrice && totalFreight > 0) {
                this.$('.totalFreightPrice').hide();
                this.$('.totalPriceLabel').html(this.$('.totalPriceLabelWithFreight').html().trim());
            }
        },

        /*
        * Telstra Latest Message
        * */
        pushLatestMessageFunction: function() {
            $.ajax({
                url: globals.path.api.westcon.getLatestMessageTelstraForOrder + $('#pdfData').data('order-number') + '?' + CSRF,
                contentType: 'application/json',
                data: {},
                method: 'POST'
            }).done(function (response) {
                if (response.success) {
                    $('.showSuccessMessage').css({display:'block'}).fadeOut(5000);
                } else {
                    $('.showErrorMessage').css({display:'block'}).fadeOut(5000);
                }
            }.bind(this)).fail(function (e) {
                console.log('error', e);
            });
        },
        /**
         * PDF file existing or not check from API
         */
        getPdf: function (orderNumber) {
            $.ajax({
                url: globals.path.api.westcon.orderPDFUrl.replace('{urlPath}', this.$('#pdfURLexisting').val()),
                type: 'GET'
            }).done(function (data) {
                if (data) {
                    this.$('#pdfData a').show();
                } else {
                    this.$('#pdfData').html(orderNumber);
                }
            }.bind(this)).fail(function() {
                this.$('#pdfData').html(orderNumber);
            }.bind(this));
        },

        /**
         * Track pdf click event
         */
        trackPdfClickEvent () {
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION);
            _satellite.track('event:order:salesOrderAcknoledgement');
        },

        /**
         * Track packing slip click event in orderDetail
         */
        trackPackingSlipClickEvent () {
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_PACKING_SLIP_ACTION, this.GTM_EVENT_PACKING_SLIP_LABEL);
            _satellite.track('event:order:viewPackingSlips');
        },

        /**
         * Track licenses
         */
        trackLicenses: function (e) {
            dataLayerAA.event = {};
            dataLayerAA.event.category = 'license_activity';
            dataLayerAA.event.action = 'view licenses';
            dataLayerAA.event.label = $(e.target).data('sapOrder');

            _satellite.track('event:order:viewlicenses');
            dataLayer.push({event: 'new_gtm_event'});
        }

    });
}(westcon));
